// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Handler = (...args: any[]) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Callbacks = Record<string, (...args: any[]) => void>;

export class EventBus<T extends Callbacks = Callbacks> {
	private listeners = new Map<keyof T, Set<Handler>>();

	on<K extends keyof T>(event: K, callback: T[K]): this {
		if (!this.listeners.has(event)) {
			this.listeners.set(event, new Set());
		}
		this.listeners.get(event)!.add(callback as Handler);
		return this;
	}

	once<K extends keyof T>(event: K, callback: T[K]): this {
		const wrapper = ((...args: Parameters<T[K]>) => {
			this.off(event, wrapper as T[K]);
			(callback as Handler)(...args);
		}) as Handler;
		return this.on(event, wrapper as T[K]);
	}

	emit<K extends keyof T>(event: K, ...args: Parameters<T[K]>): this {
		const handlers = this.listeners.get(event);
		if (handlers) {
			for (const handler of handlers) {
				handler(...args);
			}
		}
		return this;
	}

	off<K extends keyof T>(event: K, callback?: T[K]): this {
		if (callback === undefined) {
			this.listeners.delete(event);
		} else {
			this.listeners.get(event)?.delete(callback as Handler);
		}
		return this;
	}
}
